/* eslint-disable
    func-names,
    no-multi-assign,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PermissionsBase from "permissions/permissions_base";

let CommentsUnauthedPermissions;

export default CommentsUnauthedPermissions = (function () {
  CommentsUnauthedPermissions = class CommentsUnauthedPermissions extends PermissionsBase {
    static initClass() {
      // permissions for unauthenticated user
      this.prototype.permissions = {
        _renderSignInToCommentButtonView: true,
        _renderNewCommentButtonView: false,
        _renderContentSubscriptionIndicatorView: false,
        _renderReportButton: true,
        _renderModeratorControls: false,
        _renderEditorControls: false,
      };
    }
  };
  CommentsUnauthedPermissions.initClass();
  return CommentsUnauthedPermissions;
}());
